import React from 'react';
import BasicTemplate from './BasicTemplate.js'

function Rejected(props) {
    return (
        <BasicTemplate>
            <h3><b>Gracias.</b></h3>
            <h4><p>Por el momento no tenemos una oferta de crédito que se ajuste a su perfil.</p></h4>
        </BasicTemplate>
        );
};
export default Rejected;


/** WEBPACK FOOTER **
 ** ./src/components/Rejected.js
 **/